import { render, staticRenderFns } from "./PiolaFooter.vue?vue&type=template&id=36c79a60"
import script from "./PiolaFooter.vue?vue&type=script&lang=js"
export * from "./PiolaFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports